import { Timestamp } from '@firebase/firestore';
import { NestedFilter } from './generic';

export function createBatchPeriodFilter<T extends { startDate?: Timestamp; endDate?: Timestamp }>(
  start: Timestamp,
  end: Timestamp,
): NestedFilter<T> {
  return {
    or: [
      {
        and: [
          { field: 'startDate', operator: '>=', value: start },
          { field: 'startDate', operator: '<=', value: end },
        ],
      },
      {
        and: [
          { field: 'endDate', operator: '>=', value: start },
          { field: 'endDate', operator: '<=', value: end },
        ],
      },
      {
        and: [
          { field: 'startDate', operator: '<=', value: start },
          { field: 'endDate', operator: '>=', value: end },
        ],
      },
      {
        and: [
          { field: 'startDate', operator: '<=', value: end },
          { field: 'endDate', operator: '==', value: null as unknown as Timestamp },
        ],
      },
    ],
  };
}

export function createAgpPeriodFilter<T extends { createdDate?: Timestamp | Date; releasedDate?: Timestamp | Date }>(
  start: Timestamp,
  end: Timestamp,
): NestedFilter<T> {
  return {
    or: [
      {
        and: [
          { field: 'createdDate', operator: '>=', value: start },
          { field: 'createdDate', operator: '<=', value: end },
        ],
      },
      {
        and: [
          { field: 'releasedDate', operator: '>=', value: start },
          { field: 'releasedDate', operator: '<=', value: end },
        ],
      },
    ],
  };
}
